import { memo } from 'react';
// Local files
import { Root } from './Dashboard.styled';
import ChatsWidget from 'components/Dashboard/Chats/Chats';
import AnalyticsWidget from 'components/Dashboard/Analytics/Analytics';

const Dashboard = () => {

  return (
    <Root>
      <AnalyticsWidget />
      <ChatsWidget />
    </Root>
  );
};

export default memo(Dashboard);